import React, { useState } from 'react';
import { QRCodeCanvas } from 'qrcode.react';

const QRCodeGenerator = ({ url, size = 130 }) => {
  return (
    <div>
      <QRCodeCanvas value={url} size={size} includeMargin={true} />
    </div>
  );
};

export default QRCodeGenerator;
